export const endpoint = {
  1: 'https://c9plhoni3m.execute-api.us-east-2.amazonaws.com/dev/obter/questoes',
  2: 'https://private-b13710-pdiquestoesconfig.apiary-mock.com/pdi-questoes/all',
};

export const transformInObj = async arr => {
  if (arr?.length) {
    const Blocks = await arr
      .flatMap(item => {
        const keys = Object.keys(item).filter(k => k.match(/[-]/g));
        const [hasKey] = keys;
        return { [hasKey]: item[hasKey] };
      })
      .reduce(
        (acc, curr) => ({
          ...acc,
          ...curr,
        }),
        {},
      );

    const Questions = await arr
      .flatMap(item => {
        const keys = Object.keys(item).filter(k => !k.match(/[-]/g));
        const MapKeys = keys?.map(i => ({ ...item[i] }));
        return MapKeys;
      })
      .reduce(
        (acc, curr) => ({
          ...acc,
          ...curr,
        }),
        {},
      );

    const resultData = {
      blocos: {
        ...Blocks,
      },
      questoes: {
        ...Questions,
      },
    };
    return resultData;
  }
};

export const generateStates = async arr => {
  const mapQuestions = (iArea, iBloco) => (question, iQuest) => ({
    [`${iArea}-${iBloco}-${question?.id_questao}`]: {
      peso: question.peso,
      dificuldade: question.dificuldade,
    },
  });
  const mapBlocks = iArea => (bloco, iBloco) => ({
    [`${iArea}-${bloco?.id_bloco}`]: bloco.importancia,
    ...bloco.questoes?.flatMap(mapQuestions(iArea, iBloco)),
  });
  const mapAreas = (area, iArea) => area.blocos?.flatMap(mapBlocks(iArea));

  const resultData = await transformInObj(arr?.flatMap(mapAreas));

  return resultData;
};

export const sumAreaimportace = (obj, iArea) => {
  const keys = Object.keys(obj || {});
  const sumImportance = keys
    ?.filter(k => {
      const s = k.split('-')[0];
      return parseInt(s) === iArea;
    })
    .reduce((acc, curr) => acc + parseFloat(obj[curr] || 0), 0);
  return sumImportance;
};

export const attributionCondition = (number) => {
  if (number <= -1) return 0;

  if (number > 1) return 1;

  return number;
};
